import { type Options } from "#/Utilities/Platform/Options/Options.ts";

export const POS_FORCE_SYNC = "POS_FORCE_SYNC";

export enum SYNC_EVENTS {
    SYNC_START = "SYNC_START",
    SYNC_END = "SYNC_END",
    SYNC_ERROR = "SYNC_ERROR",
    SYNC_PAGE = "SYNC_PAGE",
    REQUEST_LOCATION = "REQUEST_LOCATION",
    REQUEST_LAST_SYNC = "REQUEST_LAST_SYNC",
    REQUEST_INITIAL_DATA = "REQUEST_INITIAL_DATA",
    INVALIDATE_REGISTER = "INVALIDATE_REGISTER",
    UPDATE_LOCALSTORAGE = "UPDATE_LOCALSTORAGE",
    OPEN_CLOSE_TIME = "OPEN_CLOSE_TIME",
    UPDATE_UTC_OFFSET = "UPDATE_UTC_OFFSET",
    SYNC_OFFLINE = "SYNC_OFFLINE",
    SYNC_ONLINE = "SYNC_ONLINE",
    SYNC_UNAUTHENTICATED = "SYNC_UNAUTHENTICATED",
    UPDATE_REGISTER = "UPDATE_REGISTER",
    UPDATE_OUTLET = "UPDATE_OUTLET",
    UPDATE_GLOBAL_MODE = "UPDATE_GLOBAL_MODE",
    TAKINGS_CHANGE = "TAKINGS_CHANGE",
    FORCE_UPLOAD = "FORCE_UPLOAD",
    OUTSTANDING_UPLOADS = "OUTSTANDING_UPLOADS",
    CACHE_URLS = "CACHE_URLS",
    UPLOAD_LOGS = "UPLOAD_LOGS",
}

export enum AGENT_EVENTS {
    REGISTER = "REGISTER",
    OUTLET = "OUTLET",
    GLOBAL_MODE = "GLOBAL_MODE",
    LAST_SYNC = "LAST_SYNC",
    INITIAL_DATA = "INITIAL_DATA",
    FORCE_SYNC = "FORCE_SYNC",
    SYNC_PERFORM = "SYNC_PERFORM",
    INSTANCE_ID = "INSTANCE_ID",
    DATA_RESPONSE = "DATA_RESPONSE",
}

export const FORCE_SYNC_FLAG = "sync_4";
export const FORCE_SYNC_FLAG_KEY = "force_sync_flag";

// Data to fetch for initial data of sync
export const LOCAL_INITIAL_DATA = [
    "register_current_invoice_number",
    "register_next_invoice_batch",
    "register_open_time",
    FORCE_SYNC_FLAG_KEY,
] as const satisfies Array<keyof Options>;

export type LocalInitialDataForPassing = Pick<Options, typeof LOCAL_INITIAL_DATA[number]>;
